<template>
  <Page v-bind="page"/>
</template>
<script>
import { showDialog, alert } from "@/utils";
import CheckGroup from '@/components/Page/CheckGroup.vue'
import rules from "@/rules";
import Page from "@/components/Page/BasisListPage.vue";
export default {
  props: {
    success: Function,
    close: Function,
    pars: Object
  },
  components: {
    Page
  },
  data() {
    return {
      page: {
        moduleInfo: {
          area: "Business",
          name: "TVChannel",
          direction: "电视频道",
          toolItems: [
            {
              name: "ImportTVChannel",
              title: "导入节目",
              icon: "settings_ethernet",
              async action() {
                let { url } = await this.$message.prompt({
                  title: "地址",
                  maxWidth: "500px",
                  model: {
                    url: ""
                  },
                  options: [
                    {
                      Name: "url",
                      IsTextArea: true,
                      Type: "String",
                      Description: "远程地址",
                      rules: [rules.required("远程地址")]
                    }
                  ]
                });
                url = url;
                await this.$http.post(`/api/TVChannel/ImportTVChannel`, {
                  url
                });
                alert.success("导入成功!");
              }
            },
            {
              name: "ToogleEnable",
              title: "切换状态[禁用<>启用]",
              icon: "sync_disabled",
              disabled({ selection }) {
                return selection.length != 1;
              },
              async action({ selection, rows }) {
                let { Id } = selection[0];
                await this.$http.put(`/api/TVChannel/ToogleEnable/${Id}`);
                alert.success("切换成功!");
                let index = rows.findIndex(r => r.Id == Id);
                selection[0].Enabled = !selection[0].Enabled;
              }
            },
            {
              name: "SetTVChannelCategorys",
              title: "分配分类",
              icon: "error_outline",
              disabled({ selection }) {
                return selection.length != 1;
              },
              async action({ selection }) {
                let { Id } = selection[0];
                let data = await this.$http.get(`/api/TVChannel/GetTVChannelCategorys/${Id}`);
                let ids = await showDialog(CheckGroup, {
                  title: "频道分类",
                  requestUrl: "/api/TVCategory/list",
                  model: data,
                  labelFormatter(item) {
                    return `${item.Name}`;
                  }
                });
                await this.$http.put(`/api/TVChannel/SetTVChannelCategorys/${Id}`, ids);

                alert.success("设置成功!");
              }
            }
          ]
        },
        pageInfo: {
          success: this.success,
          close: this.close,
          pars: this.pars
        }
      }
    };
  }
};
</script>
